/** Persist Past President assignee names without Member credential suffix. */
export function pastPresidentAssigneeName(displayName: string): string {
  return displayName.replace(/,\s*PGA\s*$/i, "").trim();
}
